import {A} from 'components/atoms/LinksAndButtons/A';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {Checkbox} from 'components/atoms/FormElements/Checkbox';
import {Icon} from 'components/atoms/Media/Icon';
import {Message} from 'components/atoms/Message';
import {P} from 'components/atoms/Text/P';
import {Scrollbox} from 'components/molecules/TextShowHide/Scrollbox';
import {sanitizeHtml} from 'features/services/utils/sanitize-html';
import {MessageType, HeadlineLevel} from 'features/ui/enums';
import * as React from 'react';
import {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {useModal} from "features/modal/hooks/useModal";
import { getFormattedMessage } from 'features/services/utils/language-helper';
import {Headline} from '@atoms/Text/Headline';

interface Props {
    purchaseSignupTermsText?: string;
    acceptTerms: () => void;
}

export const VipPeriodTermsModal: React.FunctionComponent<Props> = ({ purchaseSignupTermsText, acceptTerms }) => {

    const { close } = useModal();
    const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const internalSetTerms = () => {
        setTermsAccepted(!termsAccepted);
    };

    const internalAcceptTerms = () => {
        if(!termsAccepted) {
            setError(true);
            return;
        }

        acceptTerms();
    };

    const cancelTerms = () => {
        close();
    };


    return (
        <div className="vip-period-window__accept-view">
            <Headline level={HeadlineLevel.H3}>
                <FormattedMessage id="jm.components.VipPeriodWindow.acceptHeader" />
            </Headline>

            <P>
                <FormattedMessage id="jm.components.VipPeriodWindow.acceptPreamble" />
            </P>

            <Scrollbox>
                <div dangerouslySetInnerHTML={{__html: sanitizeHtml(purchaseSignupTermsText ? purchaseSignupTermsText : '')}} />
            </Scrollbox>

            {error &&
                <Message variant={MessageType.ERROR}><FormattedMessage id="jm.helpers.eidentError.acceptterms" /></Message>
            }

            <div className="vip-period-window__checkbox-container">
                <Checkbox name="accept-terms" value="accept-terms" id="accept-terms" onChange={internalSetTerms} checked={termsAccepted} />
                <label htmlFor="accept-terms"><FormattedMessage id="jm.components.VipPeriodWindow.acceptCheckboxText" /></label>
            </div>

            <div className="vip-period-window__accept-view-buttons">

                <Button 
                    onClick={internalAcceptTerms} 
                    icon={<Icon name="nets-bank-id" sizeM />} 
                    data-test-id="vip-purchase-sign" 
                    buttonColor={ButtonColor.PURCHASE} 
                    buttonSize={ButtonSize.DEFAULT} 
                    buttonType={ButtonType.DEFAULT} 
                >
                    Signering
                </Button>

                <A 
                    href="#" 
                    onClick={cancelTerms} 
                    title={getFormattedMessage('jm.components.VipPeriodWindow.acceptCancel')} 
                >
                    <FormattedMessage id="jm.components.VipPeriodWindow.acceptCancel" />
                </A>

            </div>
        </div>
    );
};
